
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/greenflame",
      function () {
        return require("private-next-pages/greenflame.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/greenflame"])
      });
    }
  